/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { atom, createStore } from "jotai/vanilla";

export const SPANGLE_MODES = {
  spangleIt: "spangle-it",
  editSize: "edit-size",
  sizeEdited: "size-edited",
  spanglesLoading: "spangles-loading"
};

const lastSpangledDimensionsDefault: { width: number | null; height: number | null } = {
  width: null,
  height: null
};

export const jotaiStore = createStore();

export const lastSpangledDimensionsAtom = atom<{ width: number | null; height: number | null }>(
  lastSpangledDimensionsDefault
);

export const spangleVariationsAtom = atom<SpangleVariation[]>([]);

export const spangleModeAtom = atom(SPANGLE_MODES.spangleIt);

export const selectedAlgorithmAtom = atom<string | null>(null);

export const originalArtworkUrlAtom = atom("");

export const spanglesMaxImageCountAtom = atom(1);

export const allAPIsCompletedStateAtom = atom(true);

export const invalidSpangleSelectedAtom = atom(false);

export const isSpangleReorderingAtom = atom(false);

export const completedSpangleDataAtom = atom<SpangleData[]>([]);

/**
 * A spangle variation entry.
 */
export interface SpangleVariation {
  algorithm: string;
  isLoading: boolean;
  error?: boolean | undefined;
  imageUrl?: string | undefined;
  spangleCsv?: string | undefined;
  spanglePagesInfo?: Record<string, unknown> | null | undefined;
  positionsJson?: string | undefined;
  [key: string]: unknown;
}

/**
 * Completed spangle data entry.
 */
export interface SpangleData {
  algorithm: string;
  [key: string]: unknown;
}
